import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";
import { getDummyText, renderStandardPictureElement } from "../../utils";

export default {
    title: "Components/Teaser Selectable Download",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    component: "ux-iws-teaser-selectable-download",
    args: {
        preselected: "true",
    },
    argTypes: {
        preselected: {
            control: "boolean",
        },
    },
};

const Template = () => html`<ux-iws-teaser-selectable-download>
    ${renderStandardPictureElement({
        width: 420,
        height: 620,
    })}
    <ux-checkbox
        slot="checkbox"
        name="whitepaper"
        value="whitepaper-1"
        no-label
    >
    </ux-checkbox>
    <span slot="file-info" class="ux-text-tiny"> 01.01.1970 PDF - 1.2MB </span>
    <div slot="text">
        <div class="ux-text-title-teaser ux-u-mb-xxxs">Wir sind für sie da</div>
        <ux-text-lines-limit
            read-more-text="Read more"
            text-lines-s="2"
            text-lines-m="3"
            text-lines-l="3"
            text-lines-xl="3"
        >
            <div class="ux-text-normal ux-text-normal--light-gray">
                ${getDummyText(300)}
            </div>
        </ux-text-lines-limit>
    </div>
</ux-iws-teaser-selectable-download>`;

export const Default = Template.bind({});

const TemplatePreselected = () => html`<ux-iws-teaser-selectable-download
    preselected="true"
>
    ${renderStandardPictureElement({
        width: 420,
        height: 620,
    })}
    <ux-checkbox
        slot="checkbox"
        name="whitepaper"
        value="whitepaper-1"
        no-label
        checked
    >
    </ux-checkbox>
    <span slot="file-info" class="ux-text-tiny"> 01.01.1970 PDF - 1.2MB </span>
    <div slot="text">
        <div class="ux-text-title-teaser ux-u-mb-xxxs">Wir sind für sie da</div>
        <ux-text-lines-limit
            read-more-text="Read more"
            text-lines-s="2"
            text-lines-m="3"
            text-lines-l="3"
            text-lines-xl="3"
        >
            <div class="ux-text-normal ux-text-normal--light-gray">
                ${getDummyText(300)}
            </div>
        </ux-text-lines-limit>
    </div>
</ux-iws-teaser-selectable-download>`;

export const Preselected = TemplatePreselected.bind({});
